module.exports = __webpack_public_path__ + "static/media/banner-autumn-2026.40a24343.webp";